import { useDispatch, useSelector } from 'react-redux';

import type { TypedUseSelectorHook, RootState, AppDispatch } from 'react-redux';

export const useAppDispatch = () => useDispatch<AppDispatch>();

export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
